import { useMemo } from 'react';
import { CropType, CropTypes } from '../../impl/blfApi/schemas/variety';
//import { useSettings } from './useSettings';

type UserCropTypesReturn = {
  blueberries: boolean;
  grapes: boolean;
  isLoading: boolean;
};

const mockCropTypes: CropType[] = [
  CropTypes.TableGrapes,
  CropTypes.Blueberries,
];

export const useUserCropTypes = (): UserCropTypesReturn => {
  // const { settings, isSettingsLoading } = useSettings();
  const { settings, isSettingsLoading } = {
    settings: {
      cropTypes: mockCropTypes,
    },
    isSettingsLoading: false,
  };

  const grapes = useMemo(() => {
    if (!settings?.cropTypes) {
      return false;
    }
    return (
      settings.cropTypes.includes(CropTypes.TableGrapes) ||
      settings.cropTypes.includes(CropTypes.JuiceGrapes) ||
      settings.cropTypes.includes(CropTypes.WineGrapes) ||
      settings.cropTypes.includes(CropTypes.VineNursery)
    );
  }, [settings?.cropTypes]);

  const blueberries = useMemo(() => {
    if (!settings?.cropTypes) {
      return false;
    }
    return settings.cropTypes.includes(CropTypes.Blueberries);
  }, [settings?.cropTypes]);

  return {
    blueberries,
    grapes,
    isLoading: isSettingsLoading,
  };
};
